import EngineModule from '../EngineModule';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'product-editor',
	dependencies :     [
		'oms-basket'
	],
	modulesBefore :    [],
	modulesAfter :     [ 'viewer-planner-furniture-editor' ],
	usableCondition :  null,
	displayCondition : {
		type : 'or',
		LHS :  {
			type :      'equal',
			component : 'K',
			property :  '[*]TARGET.hasThisModuleUsed("standing-customerMode")',
			value :     false
		},
		RHS :  {
			type :      'notequal',
			component : 'K',
			property :  '[*]TARGET.parameters.mode',
			value :     'client'
		}
	},
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	}
});
